import { SapPriceChangeRequest } from '../codegen/graphql';

export const PRICE_MISMATCH_TOLERANCE = 0.0001;

export function pricesDiffer(left: number, right: number): boolean {
    return Math.abs(left - right) > PRICE_MISMATCH_TOLERANCE;
}

export type SapPriceMismatch = {
    requested: number;
    applied: number;
};

export function getSapPriceMismatch(
    request?: Pick<
        SapPriceChangeRequest,
        'price' | 'outcomePrice' | 'outcome'
    > | null,
): SapPriceMismatch | null {
    if (
        !request ||
        request.outcome !== 'Success' ||
        request.outcomePrice == null ||
        request.price == null
    ) {
        return null;
    }

    if (!pricesDiffer(request.outcomePrice, request.price)) {
        return null;
    }

    return {
        requested: request.price,
        applied: request.outcomePrice,
    };
}

export function hasSapPriceMismatch(
    request?: Pick<
        SapPriceChangeRequest,
        'price' | 'outcomePrice' | 'outcome'
    > | null,
): boolean {
    return getSapPriceMismatch(request) != null;
}

export function getDefaultOutcomeMessage(outcome: string): string {
    if (outcome === 'Success') {
        return 'Price Adjustment Successful';
    }
    if (outcome === 'Processing') {
        return 'Processing Price Adjustment';
    }
    return 'Price Adjustment Failed';
}

export function getStatusColor(outcome?: string): string {
    if (!outcome) return 'gray';
    const lower = outcome.toLowerCase();
    if (lower.includes('success')) return 'green';
    if (lower.includes('fail')) return 'red';
    if (lower.includes('process')) return 'yellow';
    return 'gray';
}

export function getPriceAdjustmentMessage(
    mainProduct?: SapPriceChangeRequest | null,
): string {
    if (!mainProduct) {
        return 'Related SKUs only';
    }
    if (mainProduct.outcome === 'Success') {
        return 'Price Adjustment Successful';
    }
    return `Price Adjustment ${mainProduct.outcome}`;
}
